module.exports = __webpack_public_path__ + "img/icon-edit.dcd45663.svg";